export default {
    controlHub: {
        eyebrow: "Panorama operativo",
        pageSubtitle:
            "Si es tu primera vez: completa la lista de inicio, lee los tres resúmenes y actúa sobre la tabla prioritaria. Usa los filtros para el periodo.",
        onboarding: {
            sectionTitle: "Lista de inicio",
            sectionSubtitle: "Pasos fijos para conectar EveMind a tu forma de trabajar. Marca cada ítem al completarlo.",
            progressLabel: "{{pct}}% completado",
            markDone: "Marcar como hecho: {{title}}",
            todos: {
                email: {
                    title: "Conecta el correo de la empresa (Perfil → Integraciones)",
                    action: "Ir a integraciones",
                },
                profile: {
                    title: "Completa el perfil de la empresa",
                    action: "Abrir perfil",
                },
                container: {
                    title: "Crea o registra tu primer contenedor",
                    action: "Crear contenedor",
                },
                document: {
                    title: "Abre un contenedor y visualiza un documento",
                    action: "Ver contenedores",
                },
                askEve: {
                    title: "Envía tu primera pregunta a Ask Eve",
                    action: "Abrir Ask Eve",
                },
            },
        },
        clusters: {
            sectionTitle: "Tres resúmenes",
            docs: {
                eyebrow: "Documentos y flujo",
                title: "¿Están bajo control los documentos?",
                subtitle: "Proporción de envíos con documentación completa en el periodo.",
                primaryHint: "Cuanto más alto, mejor — menos faltas o controles fallidos.",
                linePending: "Envíos con documentos pendientes",
                lineDocIssues: "Incidencias documentales abiertas",
                lineCrossMissing: "Faltantes + incidencias de cruce",
                cta: "Ver envíos con problemas documentales",
            },
            risk: {
                eyebrow: "Riesgo",
                title: "¿Dónde se concentra el riesgo?",
                subtitle: "Proporción de envíos en bandas de riesgo medio o superior.",
                primaryHint: "Cuanto más bajo, mejor — prioriza alto y crítico.",
                lineHighCritical: "Alto + crítico (recuento)",
                lineMediumPlus: "Medio + alto + crítico (recuento)",
                cta: "Ver envíos en riesgo",
            },
            friction: {
                eyebrow: "Fricción logística",
                title: "¿Dónde hay fricción operativa?",
                subtitle: "Incidencias no documentales y envíos activos — señales de retrasos y excepciones.",
                primaryHint: "Más incidencias no documentales implica más excepciones que resolver.",
                lineInTransit: "En tránsito (envíos)",
                lineAboutToDepart: "Próximas salidas (ETD en 2 días, reservado)",
                lineReviewCenter: "Review Center (elementos pendientes)",
                lineAllIssues: "Todas las incidencias activas (total)",
                topRoute: "Lane principal (por actividad): {{route}}",
                ctaIssues: "Abrir incidencias",
                ctaReview: "Abrir Review Center",
            },
        },
        ledger: {
            title: "Envíos prioritarios (por valor en riesgo)",
            description:
                "Los contenedores de mayor impacto en el periodo. Abre una fila para documentos, incidencias y línea de tiempo.",
        },
        companySnapshot: {
            title: "Perfil operativo",
            subtitle: "Contexto sobre rutas y mercancías — útil después de atender lo prioritario.",
        },
        hubCompanySnapshot: {
            title: "Cómo operas",
            subtitle: "Contexto breve del perfil — abre el perfil completo para más detalle.",
            loadError: "No se pudo cargar el perfil de la empresa.",
            metricActivePartners: "Socios activos",
            metricTotalContainers: "Contenedores (histórico)",
            metricTotalContainersFiltered: "Contenedores (periodo seleccionado)",
            metricUniqueRoutes: "Rutas únicas",
            metricCommodities: "Mercancías",
            topRoutesTitle: "Rutas principales",
            colRoute: "Ruta",
            colShipments: "Envíos",
            colValue: "Valor",
            openProfile: "Abrir perfil completo",
        },
        toolbar: {
            clear: "Limpiar",
            carrierPlaceholder: "Naviera",
            statusPlaceholder: "Estado",
            allCarriers: "Todas las navieras",
            allStatuses: "Todos los estados",
            includeMediumRisk: "Incluir riesgo medio",
        },
        quickStats: {
            title: "Cifras clave ({{start}} – {{end}})",
            titleNoRange: "Cifras clave",
            subtitle: "Accesos a listas filtradas. El detalle está en los resúmenes y la tabla.",
        },
        tabs: {
            containerSummary: "Resumen de Contenedores",
            companyStats: "Estadísticas de Empresa",
        },
        timeRange: {
            thisMonth: "Este Mes",
            last3Months: "Últimos 3 Meses",
            last6Months: "Últimos 6 Meses",
            last9Months: "Últimos 9 Meses",
            thisYear: "Este Año",
        },
        stats: {
            activePartners: "Socios Activos",
            teamMembers: "Miembros del Equipo",
            pendingReviews: "Review Center - elementos pendientes",
        },
        tooltips: {
            docIssues: {
                title: "Contenedores con problemas documentales",
                description: "Número de contenedores con al menos un problema documental activo (documentos faltantes, fallos de verificación, errores de cruce)",
            },
            issues: {
                title: "Problemas",
                description: "Total de problemas activos en todos los contenedores",
            },
            atRisk: {
                title: "Envíos en riesgo",
                description: "Contenedores con puntuación de riesgo ≥ 25% (medio, alto, crítico)",
            },
            highRisk: {
                title: "Envíos de Alto Riesgo",
                description: "Contenedores con puntuación de riesgo ≥ 50% que requieren atención",
            },
            activePartners: {
                title: "Socios Comerciales Activos",
                description: "Empresas con las que tienes envíos activos (consignatarios, transitarios)",
            },
            teamMembers: {
                title: "Miembros del Equipo Activos",
                description: "Usuarios en tu organización con acceso a este workspace",
            },
            pendingReviews: {
                title: "Revisiones pendientes",
                description:
                    "Elementos pendientes de revisión humana — identificación de contenedor, asignación de documentos, comprobaciones de tracking",
            },
        },
        coordinationHub: {
            title: "Qué mirar primero",
            subtitle: "Tres áreas distintas: novedades, incidencias y revisiones humanas — accede desde aquí.",
            glossaryLink: "¿En qué se diferencian?",
            glossaryTitle: "Actividad, incidencias y Review Center",
            cards: {
                activity: "Actividad",
                activityHint: "Feed y novedades relacionadas con el correo",
                issues: "Incidencias",
                issuesHint: "Problemas abiertos en envíos y documentos",
                review: "Review Center",
                reviewHint: "Elementos que requieren decisión humana",
                unread: "sin leer en el feed",
                open: "incidencias abiertas",
                pending: "revisiones pendientes",
            },
            glossary: {
                activityTerm: "Actividad",
                activityBody:
                    "Tu feed cronológico: comunicaciones comerciales, avisos del sistema e indicadores de no leído sobre lo que cambió recientemente.",
                issuesTerm: "Incidencias",
                issuesBody:
                    "Problemas estructurados ligados a contenedores o documentos (faltan documentos, comprobaciones, retrasos). Es tu cola operativa de excepciones.",
                reviewTerm: "Review Center",
                reviewBody:
                    "Cola corta para confirmación humana (p. ej. asignación de documentos, identificación). No es el feed general de actividad.",
            },
        },
        firstSession: {
            title: "Primeros pasos en EveMind",
            dismiss: "Cerrar",
            stepEmail: "Conecta tu correo (Integraciones en Perfil)",
            stepContainer: "Abre un contenedor desde la lista para ver documentos, línea de tiempo e incidencias",
            stepReview: "Revisa el Review Center si tienes revisiones pendientes",
        },
        riskyShipments: {
            title: "Envíos de Riesgo",
            description: "Contenedores de alto riesgo ordenados por valor en riesgo",
            emptyState: "No se encontraron envíos de alto riesgo",
            colStatus: "Estado",
            viewAll: "Ver todo",
        },
        companyProfile: {
            title: "Perfil de Empresa",
            profileCompleteness: "Completitud del Perfil",
            tradingPattern: "Patrón Comercial",
            volumeTier: "Nivel de Volumen",
            commodities: "Mercancías",
            tradeRoutes: "Rutas Comerciales",
            partners: "Socios Comerciales",
            containers: "Actividad de Contenedores",
            topHsCodes: "Códigos HS Principales",
            topRoutes: "Rutas Principales",
        },
    },
    admin: {
        title: "Dashboard",
        subtitle: "Vista general del sistema y gestión de cuentas",
        newAccount: "Nueva Cuenta",
        loading: "Cargando dashboard...",
        stats: {
            totalAccounts: "Total de Cuentas",
            activeAccounts: "Cuentas Activas",
            newThisMonth: "Nuevas Este Mes",
            suspendedAccounts: "Cuentas Suspendidas",
        },
        recentAccounts: {
            title: "Cuentas Recientes",
            description: "Últimas 5 cuentas creadas en el sistema",
            viewAll: "Ver todas",
            headers: {
                userType: "Tipo de Usuario",
                legalName: "Nombre Legal",
                entityType: "Tipo de Entidad",
                country: "País",
                status: "Estado",
                createdAt: "Fecha de Creación",
            },
            status: {
                active: "Activo",
                suspended: "Suspendido",
                inactive: "Inactivo",
            },
        },
    },
    sender: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores y colaboraciones",
        loading: "Cargando dashboard...",
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores creados",
            viewAll: "Ver todos",
            headers: {
                containerId: "Ref. Contenedor",
                route: "Ruta",
                progress: "Progreso",
                eta: "ETA",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
                value: "Valor",
            },
        },
    },
    shipper: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores y colaboraciones",
        loading: "Cargando dashboard...",
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
            containersWithDocIssues: "Con problemas doc",
            issues: "Con problemas",
            atRisk: "En riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores creados",
            viewAll: "Ver todos",
            headers: {
                containerId: "Ref. Contenedor",
                route: "Ruta",
                progress: "Progreso",
                eta: "ETA",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
                value: "Valor",
            },
        },
    },
    receiver: {
        title: "Dashboard",
        subtitle: "Vista general de contenedores recibidos y colaboraciones",
        loading: "Cargando dashboard...",
        newOrderRequest: "Nueva Solicitud de Pedido",
        manageShippers: "Gestionar Expedidores",
        viewContainers: "Ver Contenedores",
        newOrderModal: {
            title: "Nueva Solicitud de Pedido",
            shipper: "Expedidor",
            shipperPlaceholder: "Selecciona un expedidor",
            targetWeek: "Semana Objetivo",
            packingList: "Lista de Empaque Solicitada",
            packingListPlaceholder: "Describe en detalle la lista de empaque solicitada...",
            notes: "Notas",
            notesPlaceholder: "Notas adicionales sobre el pedido...",
            submit: "Crear Pedido"
        },
        stats: {
            totalContainers: "Total de Contenedores",
            inTransit: "En Tránsito",
            delivered: "Entregados",
            delayed: "Retrasados",
            pendingDocuments: "Documentos Pendientes",
            highRisk: "Alto Riesgo",
        },
        collaborations: {
            title: "Colaboraciones",
            total: "Total",
            active: "Activas",
            pending: "Pendientes",
        },
        team: {
            title: "Equipo",
            total: "Total",
            active: "Activos",
        },
        recentContainers: {
            title: "Contenedores Recientes",
            description: "Últimos 5 contenedores recibidos",
            viewAll: "Ver todos",
            headers: {
                containerId: "Ref. Contenedor",
                shipper: "Expedidor",
                route: "Ruta",
                progress: "Progreso",
                docStatus: "Estado Doc",
                riskLevel: "Nivel de Riesgo",
            },
        },
        monthlyTrend: {
            title: "Tendencia Mensual",
        },
        trendVsLastMonth: "vs mes pasado",
        receivedContainers: "Contenedores Recibidos",
        activeShippers: "Expedidores Activos",
        charts: {
            commodityDistribution: "Distribución de Mercancías",
            originCountries: "Países de Origen",
            arrivalPorts: "Puertos de Llegada",
        },
    },
};

